

export class VisitanteDTO {
	public visitantePK: VisitantePK;
	public nombreCompleto: string;
	public correoVisitante: string;
	public empresa: string;
	public tipo: string;
	public urlFoto: string;
	public genero: string;
	public telefono: string;
	public primerNombre: string;
	public segundoNombre: string;
	public primerApellido: string;
	public segundoApellido: string;
	public nombres: string;
	public apellidos: string;

}




export class VisitantePK {
	public tipoDocVisitante: string;
	public numDocVisitante: string;

}
